import { CONSTANT_TABLE } from '@/components/Table/list-table/interface';
import { COLORS } from '@/modules/orders/utils/constants';

import { path } from '@/routes/paths';
import { translates } from '@/utils';
import { Chip } from '@mui/material';

export const TABLE_HEAD_USERS: CONSTANT_TABLE[] = [
  { id: 'id', label: 'ID', align: 'left' },
  { id: 'uid', label: 'UID', align: 'left' },
  { id: 'name', label: translates.name, align: 'left' },
  { id: 'email', label: translates.email, align: 'left' },
  { id: 'phone', label: translates.phone, align: 'left' },
  {
    id: 'rol.name',
    label: translates.rol,
    align: 'left',
    wrapComponent: (value) => value || 'sin Rol',
  },

  {
    id: 'isDelete',
    label: translates.status,
    align: 'center',
    wrapComponent: (value) => (<Chip color={(!value ? COLORS.done : COLORS.cancelled) as any} label={!value ? translates.active : translates.disable} />),
  },

  { id: 'otra', disableSort: true },
];

export enum STATUS {
  CREATED = 'created',
  PAID = 'paid',
  CANCEL = 'cancel',
}

export const PATH_RESERVATION = (ROOTS_DASHBOARD: string) => ({
  root: path(ROOTS_DASHBOARD, '/users'),
  list: path(ROOTS_DASHBOARD, '/users/list'),
  view: (name: number) => path(ROOTS_DASHBOARD, `/users/${name}`),
  edit: (name: number) => path(ROOTS_DASHBOARD, `/users/${name}/edit`),
});
